import React from 'react';
import styles from './Logo.module.css';

const Logo = props => (
    <div className={ styles.Logo }>
        <p>AerobertLogo</p>
    </div>
);

export default Logo;